import styled from 'styled-components';

export const BookmarksGrid = styled.div`
  display: grid;
  gap: 32px;
  grid-template-columns: repeat(auto-fill, minmax(225px, 1fr));

  @media (max-width: 1240px) {
    gap: 20px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.xl}) {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    gap: 13px;
    grid-template-columns: repeat(auto-fill, minmax(166px, 1fr));
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.xsm}) {
    gap: 13px;
    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  }
`;
